import LegalLayout, {
  LegalSection,
  LegalList,
  LegalParagraph,
} from './LegalLayout';

/**
 * Terms of Service — Google-safe version supplied by the operator.
 * Renders the full source text verbatim with consistent styling.
 */
export default function TermsOfServicePage() {
  return (
    <LegalLayout title="Terms of Service" effectiveDate="April 26, 2026">
      <LegalSection number={1} title="Agreement">
        <LegalParagraph>By using VegasLobby, you agree to these Terms.</LegalParagraph>
      </LegalSection>

      <LegalSection number={2} title="Service Description">
        <LegalParagraph>
          VegasLobby is a digital entertainment and virtual credit-based platform that allows users to:
        </LegalParagraph>
        <LegalList
          items={[
            'Create accounts',
            'Access interactive content',
            'Manage virtual balances',
            'Use integrated services',
          ]}
        />
      </LegalSection>

      <LegalSection number={3} title="Account Responsibility">
        <LegalParagraph>Users must:</LegalParagraph>
        <LegalList
          items={[
            'Provide accurate information',
            'Maintain account security',
            'Be responsible for all activity under their account',
          ]}
        />
      </LegalSection>

      <LegalSection number={4} title="Acceptable Use">
        <LegalParagraph>You agree NOT to:</LegalParagraph>
        <LegalList
          variant="cross"
          items={[
            'Exploit system vulnerabilities',
            'Access unauthorized accounts',
            'Manipulate balances or transactions',
            'Use bots or automation without permission',
          ]}
        />
      </LegalSection>

      <LegalSection number={5} title="Virtual Credits">
        <LegalList
          items={[
            'Credits are part of the platform system',
            'They have no independent value outside the platform unless explicitly stated',
            'We may adjust balances in case of system errors or abuse',
          ]}
        />
      </LegalSection>

      <LegalSection number={6} title="Authentication">
        <LegalParagraph>
          We support third-party authentication such as Google Sign-In. Users agree to comply with
          those providers&apos; terms.
        </LegalParagraph>
      </LegalSection>

      <LegalSection number={7} title="Platform Integrity">
        <LegalParagraph>We reserve the right to:</LegalParagraph>
        <LegalList
          items={[
            'Monitor activity',
            'Suspend accounts',
            'Reverse invalid transactions',
          ]}
        />
      </LegalSection>

      <LegalSection number={8} title="Availability">
        <LegalParagraph>We do not guarantee uninterrupted service.</LegalParagraph>
      </LegalSection>

      <LegalSection number={9} title="Limitation of Liability">
        <LegalParagraph>
          The service is provided &ldquo;as is&rdquo;. We are not liable for:
        </LegalParagraph>
        <LegalList
          items={[
            'Service interruptions',
            'Data loss',
            'Account issues resulting from user negligence',
          ]}
        />
      </LegalSection>

      <LegalSection number={10} title="Termination">
        <LegalParagraph>We may suspend or terminate accounts for:</LegalParagraph>
        <LegalList
          items={[
            'Policy violations',
            'Security risks',
            'Abuse or fraud',
          ]}
        />
      </LegalSection>

      <LegalSection number={11} title="Modifications">
        <LegalParagraph>We may update terms at any time.</LegalParagraph>
      </LegalSection>

      <LegalSection number={12} title="Contact">
        <LegalParagraph>
          <a
            href="mailto:support@vegaslobby.com"
            className="text-[#D4AF37] hover:underline"
            data-testid="terms-contact-email"
          >
            support@vegaslobby.com
          </a>
        </LegalParagraph>
      </LegalSection>
    </LegalLayout>
  );
}
